module.exports = __webpack_public_path__ + "d5623da278cde3316b1f511306d2f15e.jpg";